"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateQuoteExpiryDate = exports.eInsuranceQuoteRejectionReason = void 0;
const insuranceQuote_1 = require("../insuranceQuote");
const utils_1 = require("@loadsure/utils");
const date_fns_1 = require("date-fns");
const insuranceQuote_class_1 = __importDefault(require("./insuranceQuote.class"));
var eInsuranceQuoteRejectionReason;
(function (eInsuranceQuoteRejectionReason) {
    eInsuranceQuoteRejectionReason["REJCOP"] = "Shipment lost to competition";
    eInsuranceQuoteRejectionReason["REJVAL"] = "Insured value changed";
    eInsuranceQuoteRejectionReason["REJREQ"] = "Insurance was not required by the shipper";
    eInsuranceQuoteRejectionReason["REJCHP"] = "Cheaper insurance found elsewhere";
    eInsuranceQuoteRejectionReason["REJREP"] = "Origin/destination/commodity changed";
    eInsuranceQuoteRejectionReason["REJASD"] = "Assured changed";
    eInsuranceQuoteRejectionReason["REJNLN"] = "Insurance no longer needed";
    eInsuranceQuoteRejectionReason["REJQCE"] = "Quote created in error";
    eInsuranceQuoteRejectionReason["REJOTH"] = "Other";
})(eInsuranceQuoteRejectionReason = exports.eInsuranceQuoteRejectionReason || (exports.eInsuranceQuoteRejectionReason = {}));
const calculateQuoteExpiryDate = (createdDateISO, stop, maxQuoteLifetimeInDays = insuranceQuote_1.DAYS_TO_EXPIRE_QUOTE) => {
    const createdDate = date_fns_1.parseISO(createdDateISO);
    const expiryFromCreated = date_fns_1.addDays(createdDate, maxQuoteLifetimeInDays);
    if (stop === null || stop === void 0 ? void 0 : stop.date) {
        const endOfStopDay = utils_1.endOfDayFromISODateCountryState(stop.date, stop.country, stop.state);
        return date_fns_1.min([endOfStopDay, expiryFromCreated]);
    }
    return expiryFromCreated;
};
exports.calculateQuoteExpiryDate = calculateQuoteExpiryDate;
exports.default = insuranceQuote_class_1.default;
//# sourceMappingURL=index.js.map